const init = (callback) => {
  const toast = document.getElementById("snackbar");

  setTimeout(() => {
    toast.classList.add("show");
  }, 1000); // maybe not the best solution, perhaps this should be fixed with an css animation

  toast.addEventListener("click", () => {
    // maybe not the best solution, perhaps  use the knock-out function binding
    toast.classList.remove("show");
    callback();
  });
};

export default init;
